
export const color = {
  main: '#D5AA00',
  white: '#FFFFFF',
  lightShades: '#F2F0F2',
  darkShades: '#2C3132',
  lightAccent: '#D5AA00',
  darkAccent: '#F8F7F8'
}



// WEBPACK FOOTER //
// ./src/variables.js